import React from "react"
import searchTicketImage from "../../../public/static/images/svg/fetcher/ticketSearch.svg"

const SearchTicketLogo = () => {
  return (
    <img
      src={searchTicketImage}
      alt="Search for your parking ticket"
      style={{ paddingTop: ".75rem" }}
    />
  )
}

export default SearchTicketLogo
